import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import { BsChevronDown } from "react-icons/bs";
import { useHistory } from 'react-router-dom'
import { getUrlQueries } from '../Utilities/url';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
  selected: {
    backgroundColor: "#070d4b !important",
  },
}))(MenuItem);

export default function CustomizedMenus({ anchorEl, setAnchorEl, sections, setSection }) {

  const history = useHistory()

  const handleClick2 = (event: React.MouseEvent<HTMLElement>) => {
    setSection("All")
    setAnchorEl(event.currentTarget);
    history.push("/video")
  };

  const handleClick3 = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSection = (section) => {
    history.push("video")
    setSection(section)
    setAnchorEl(null)
  }

  const handleClose = () => {
    setAnchorEl(null);
  }

  const selectedSection = getUrlQueries().section

  return (
    <div style={{ cursor: "pointer", zIndex: 1500 }}>
      <Button
        style={anchorEl ? { backgroundColor: "#070d4b", color: "#fff" } : { cursor: "pointer" }}
        aria-controls="customized-menu"
        aria-haspopup="true"
        onClick={handleClick2}
        onMouseOver={handleClick3}
        endIcon={<BsChevronDown />}
      >
        RECORDED LIVE SESSION
      </Button>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <StyledMenuItem // default section to prevent unwant default selected menu
          selected={selectedSection === "All"}
          style={{ display: "none" }}
        />
        {(sections || []).map((a, i) =>
          <StyledMenuItem
            key={i}
            onClick={() => handleSection(a.sectionName)}
            selected={a.sectionName === selectedSection}
          >
            <ListItemText primary={a.sectionName || ""} />
          </StyledMenuItem>
        )}
      </StyledMenu>
    </div>
  );
}